import { createRoot } from 'react-dom/client'
import App from './App.tsx'
import { AppProviders } from './providers/AppProviders'
import { ErrorBoundary } from './components/shared/ErrorBoundary'
import { setCfAccountHash, setR2PublicBase } from '@agciceyim/shared'
import './index.css'

// Surface preview-mode flag for shared/apiClient (avoids import.meta in shared/).
;(globalThis as { __AGCICEYIM_PREVIEW_MODE__?: boolean }).__AGCICEYIM_PREVIEW_MODE__ =
  import.meta.env?.VITE_PREVIEW_MODE === 'true'

// Initialize CF Images account hash for image URL resolution
setCfAccountHash(import.meta.env.VITE_CF_IMAGES_ACCOUNT_HASH || '')
// Rewrite raw r2.dev URLs → custom domain (Cloudflare R2 Custom Domain)
setR2PublicBase('https://media.agciceyim.az/')

createRoot(document.getElementById('root')!).render(
  <ErrorBoundary>
    <AppProviders>
      <App />
    </AppProviders>
  </ErrorBoundary>
)

